/**
 * Category Master Screen (4.3.3) - Orchestrator
 * Procurement → Item Attributes → Category Master
 * 
 * Flow: Grid Screen ↔ Form Screen (Add/Edit/View)
 * Strict ERP pattern: Menu click → Grid → Add/Edit Form
 */
import React, { useState, useEffect } from 'react';
import CategoryMasterGrid from './CategoryMasterGrid';
import CategoryMasterForm from './CategoryMasterForm';
import { API_BASE as API_URL, getToken} from '../../../lib/api';


const CategoryMasterScreen = ({ theme = 'light' }) => {
  const [view, setView] = useState('grid'); // 'grid' | 'form'
  const [editData, setEditData] = useState(null);
  const [formMode, setFormMode] = useState('add'); // 'add' | 'edit' | 'view'
  const [token, setToken] = useState('');

  // Get auth token from localStorage (stored as 'retailcliq_token' by authAPI)
  useEffect(() => {
    const stored = getToken();
    if (stored) setToken(stored);
  }, []);

  const handleAddNew = () => {
    setEditData(null);
    setFormMode('add');
    setView('form');
  };

  const handleEdit = (row, mode = 'edit') => {
    setEditData(row);
    setFormMode(mode);
    setView('form');
  };

  const handleGridView = () => {
    setView('grid');
    setEditData(null);
  };

  if (view === 'form') {
    return (
      <CategoryMasterForm
        theme={theme}
        token={token}
        editData={editData}
        mode={formMode}
        onGridView={handleGridView}
        onSaved={handleGridView}
      />
    );
  }

  return (
    <CategoryMasterGrid
      theme={theme}
      token={token}
      onAddNew={handleAddNew}
      onEdit={handleEdit}
      onBack={() => {}}
    />
  );
};

export default CategoryMasterScreen;
